import { fromAddress, setKey, setLanguage, setRegion } from 'react-geocode';

import {
    FETCH_GEOCODE,
    FETCH_GEOCODE_FAILURE,
    FETCH_GEOCODE_SUCCESS,
} from '../actionTypes';
import { creditFileActions } from '../reducer';

export default (str) => (dispatch) => {
    setKey(import.meta.env.VITE_GOOGLE_MAPS_KEY);
    setLanguage('es-MX');
    setRegion('mx');

    dispatch(creditFileActions[FETCH_GEOCODE]());

    return fromAddress(str).then(
        (response) =>
            dispatch(
                creditFileActions[FETCH_GEOCODE_SUCCESS](response.results),
            ),
        (error) =>
            dispatch(
                creditFileActions[FETCH_GEOCODE_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
    );
};
